import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialBox from "../../../components/MaterialBox";
import MaterialSelect from "../../../components/MasterSelect";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import { useLoading } from "../../../context/loading";
import { fetchAll } from "../../../ApiBaseUrl";

function SalaryReport() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { circleLoading, setCirleLoading } = useLoading();
  const [rows, setRows] = useState([]);
  const [reportData, setReportData] = useState({
    month: "",
    year: "",
    category: "",
    type: "",
    branch: "",
    shift: "",

    monthStatus: "unchecked",
    yearStatus: "unchecked",
    categoryStatus: "unchecked",
    typeStatus: "unchecked",
    branchStatus: "unchecked",
    shiftStatus: "unchecked",
  });
  console.log(reportData, "reportData");

  const handleReset = () => {
    setReportData({
      month: "",
      year: "",
      category: "",
      type: "",
      branch: "",
      shift: "",
    });
    setRows([]);
    filterData();
  };

  const columns = [
    // {
    //   field: "id",
    //   headerName: "S.No.",
    //   width: "0.5",
    //   disableColumnMenu: true,
    //   editable: false,
    //   sortable: true
    // },
    {
      field: "empid",
      headerName: "EmpID",
      // width: "0.5",
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "firstName",
      headerName: "Employee Name",

      // flex: 2,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "branch",
      headerName: "Branch",
      // flex: 2,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "category",
      headerName: "Category",
      // flex: 2,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "month",
      headerName: "Month",
      // flex: 2,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "year",
      headerName: "Year",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "monthDays",
      headerName: "Month Days",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "salaryDays",
      headerName: "Salary Days",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "absentDays",
      headerName: "Absent Days",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "mealsDays",
      headerName: "Meals Days",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "shiftPaiseDays",
      headerName: "Shift Paise Days",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "otHours",
      headerName: "OT Hours",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "basicAmount",
      headerName: "Basic Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "daAmount",
      headerName: "DA Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "mealsAmountPerDay",
      headerName: "Meals Amount Per Day",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "otAmountPerHour",
      headerName: "OT Amount Per Hour",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "shiftPaisa",
      headerName: "Shift Paisa",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "attendanceAmount",
      headerName: "Attendance Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "busFare",
      headerName: "Bus Fare",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "esiAmount",
      headerName: "ESI Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "pfAmount",
      headerName: "PF Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "advanceAmount",
      headerName: "Advance Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "bonusAmount",
      headerName: "Bonus Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "earnedBasic",
      headerName: "Earned Basic",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "earnedDa",
      headerName: "Earned DA",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "lopAmount",
      headerName: "LOP Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "otAmount",
      headerName: "OT Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "shiftPaiseAmount",
      headerName: "Shift Paise Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "attendanceAllowance",
      headerName: "Attendance Allowance",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "mealsAmount",
      headerName: "Meals Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "grossPay",
      headerName: "Gross Pay",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "totalAmount",
      headerName: "Total Amount",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "netPay",
      headerName: "Net Pay",
      // flex: 1,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
  ];
  const monthOptions = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
  const yearOptions = [
    { value: "2022", label: "2022" },
    { value: "2023", label: "2023" },
    { value: "2024", label: "2024" },
    { value: "2025", label: "2025" },
    { value: "2026", label: "2026" },
    { value: "2027", label: "2027" },
    { value: "2028", label: "2028" },
  ];
  const categoryOptions = [
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
  ];
  const typeOptions = [
    { value: "Staff", label: "Staff" },
    { value: "Operators", label: "Operators" },
  ];
  const branchOptions = [
    { value: "Branch1", label: "Branch1" },
    { value: "Branch2", label: "Branch2" },
    { value: "Branch3", label: "Branch3" },
    { value: "Branch4", label: "Branch4" },
  ];
  const shiftOptions = [
    { value: "Day", label: "Day" },
    { value: "Night", label: "Night" },
  ];

  const filterData = async () => {
    setCirleLoading(true);
    try {
      const response = await axios.post(BASEURL, {
        query: `
      query SalaryReportsQueries($month: Int!, $year: Int!, $category: String, $employeeType: String, $branch: String, $shift: String) { 
      salaryPfEsiReportsQueries(month: $month, year: $year, category: $category, employeeType: $employeeType, branch: $branch, shift: $shift ) { 
        id 
        employee { 
            id 
            firstName 
            empid 
            branch 
            category 
            dateOfJoining 
            employeeType 
            uanNumber 
            esicNumber 
          } 
          month 
          year 
          monthDays 
          salaryDays 
          absentDays 
          mealsDays 
          shiftPaiseDays 
          otHours 
          basicAmount 
          daAmount 
          mealsAmountPerDay 
          otAmountPerHour 
          shiftPaisa 
          attendanceAmount 
          busFare 
          esiAmount 
          pfAmount 
          advanceAmount  
          bonusAmount 
          earnedBasic 
          earnedDa 
          lopAmount 
          otAmount 
          shiftPaiseAmount 
          busFare 
          attendanceAllowance 
          mealsAmount 
          grossPay 
          totalAmount 
          netPay 
        } 
    } `,
        variables: {
          month: reportData.month?.value || null,
          year: reportData.year?.value || null,
          category: reportData.category?.value || null,
          employeeType: reportData.type?.value || null,
          branch: reportData.branch?.value || null,
          shift: reportData.shift?.value || null,
        },
      });

      const result = response?.data?.data?.salaryPfEsiReportsQueries || [];
      setRows(
        result.map((item, index) => ({
          id: index + 1,
          empid: item.employee.empid,
          firstName: item.employee.firstName,
          branch: item.employee.branch,
          category: item.employee.category,
          month: item.month,
          year: item.year,
          monthDays: item.monthDays,
          salaryDays: item.salaryDays,
          absentDays: item.absentDays,
          mealsDays: item.mealsDays,
          shiftPaiseDays: item.shiftPaiseDays,
          otHours: item.otHours,
          basicAmount: item.basicAmount,
          daAmount: item.daAmount,
          mealsAmountPerDay: item.mealsAmountPerDay,
          otAmountPerHour: item.otAmountPerHour,
          shiftPaisa: item.shiftPaisa,
          attendanceAmount: item.attendanceAmount,
          busFare: item.busFare,
          esiAmount: item.esiAmount,
          pfAmount: item.pfAmount,
          advanceAmount: item.advanceAmount,
          bonusAmount: item.bonusAmount,
          earnedBasic: item.earnedBasic,
          earnedDa: item.earnedDa,
          lopAmount: item.lopAmount,
          otAmount: item.otAmount,
          shiftPaiseAmount: item.shiftPaiseAmount,
          attendanceAllowance: item.attendanceAllowance,
          mealsAmount: item.mealsAmount,
          grossPay: item.grossPay,
          totalAmount: item.totalAmount,
          netPay: item.netPay,
        }))
      );
    } catch (error) {
      console.error("Error filtering data", error);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (reportData.month && reportData.year) {
      filterData();
    } else {
      setRows([]);
    }
  }, [
    reportData.month,
    reportData.year,
    reportData.category,
    reportData.branch,
    reportData.shift,
    reportData.type,
  ]);

  const exportToExcel = () => {
    if (!Array.isArray(rows) || rows.length === 0) {
      console.error("No data available for export.");
      return;
    }

    const header = [
      "S.No.",
      "EmpID",
      "Employee Name",
      "Branch",
      "Category",
      "Month",
      "Year",
      "Month Days",
      "Salary Days",
      "Absent Days",
      "Meals Days",
      "Shift Paise Days",
      "OT Hours",
      "Basic Amount",
      "DA Amount",
      "Meals Amount Per Day",
      "OT Amount Per Hour",
      "Shift Paisa",
      "Attendance Amount",
      "Bus Fare",
      "ESI Amount",
      "PF Amount",
      "Advance Amount",
      "Bonus Amount",
      "Earned Basic",
      "Earned DA",
      "LOP Amount",
      "OT Amount",
      "Shift Paise Amount",
      "Attendance Allowance",
      "Meals Amount",
      "Gross Pay",
      "Total Amount",
      "Net Pay",
    ];
console.log('row:',rows)
    const data = rows.map((row) => [
      row.id || "",
      row.empid || "",
      row.firstName || "",
      row.branch || "",
      row.category || "",
      row.month || "",
      row.year || "",
      row.monthDays || "",
      row.salaryDays === 0 ? 0 : row.salaryDays,
      row.absentDays || "",
      row.mealsDays === 0 ? 0 :  row.mealsDays,
      row.shiftPaiseDays || "0",
      row.otHours || "",
      row.basicAmount || "",
      row.daAmount || "",
      row.mealsAmountPerDay || "",
      row.otAmountPerHour || "",
      row.shiftPaisa || "",
      row.attendanceAmount || "",
      row.busFare || "",
      row.esiAmount || "",
      row.pfAmount || "",
      row.advanceAmount || "",
      row.bonusAmount || "",
      row.earnedBasic || "",
      row.earnedDa || "",
      row.lopAmount || "",
      row.otAmount || "",
      row.shiftPaiseAmount || "",
      row.attendanceAllowance || "",
      row.mealsAmount || "",
      row.grossPay || "",
      row.totalAmount || "",
      row.netPay || "",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([header, ...data]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Salary Report");

    XLSX.writeFile(workbook, "Salary_Report.xlsx");
    console.log('workbook:',workbook)
  };

  const handleDropdownChange = (name, selectedOption) => {
    console.log("option:", selectedOption);

    // const selectedValue = selectedOption?.value ?? "";

    setReportData((prevreportData) => {
      const updatedState = {
        ...prevreportData,
        [name]: selectedOption,
        [`${name}Status`]: selectedOption ? "success" : "unchecked",
      };
      console.log("updated:", updatedState);
      return updatedState;
    });
  };
  const [branchList, setBranchList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  console.log(branchList, "branchList");

  useEffect(() => {
    const fetchBranches = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        console.log("All Branches:", data);
        setBranchList(data?.allBranch);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);
  useEffect(() => {
    onShiftDetails();
  }, []);
  const onShiftDetails = async () => {
    // setCirleLoading(true);
    const query = `
      query allShifts{
allShifts {
  id
  name
  startTime
  endTime
  totalWorkingHours
}
}
      `;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const shiftData = response.data?.data?.allShifts; // Adjusted field name
      if (shiftData) {
        setShiftList(shiftData);
      } else {
        console.error("Error: Shift data not found in response.");
      }
      // setCirleLoading(false);
    } catch (error) {
      // setCirleLoading(false);
      console.error("ResponseError:", error);
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <IconButton
                  onClick={() => {
                    navigate("/report");
                  }}
                  sx={{ mr: 1, mt: -0.7 }}
                >
                  <ArrowBackIcon />
                </IconButton>{" "}
                <MaterialTypography variant="h5" fontWeight="medium">
                  Salary Report
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "20vh" }}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={1}
            padding={1}
          >
            {/* Start Date */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Month<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="month"
                options={monthOptions}
                value={reportData.month}
                onChange={(selectedOption) =>
                  handleDropdownChange("month", selectedOption)
                }
                success={reportData.monthStatus === "success" ? true : false}
                isClearable
              />
            </Grid>

            {/* End Date */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Year<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="year"
                options={yearOptions}
                value={reportData.year}
                onChange={(selectedOption) =>
                  handleDropdownChange("year", selectedOption)
                }
                success={reportData.yearStatus === "success" ? true : false}
                isClearable
              />
            </Grid>

            {/* Category */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Category
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="category"
                options={categoryOptions}
                value={reportData.category}
                onChange={(selectedOption) =>
                  handleDropdownChange("category", selectedOption)
                }
                success={reportData.categoryStatus === "success" ? true : false}
                isClearable
              />
            </Grid>

            {/* Type */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Type
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="type"
                options={typeOptions}
                value={reportData.type}
                onChange={(selectedOption) =>
                  handleDropdownChange("type", selectedOption)
                }
                success={reportData.typeStatus === "success" ? true : false}
                isClearable
              />
            </Grid>

            {/* Branch */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Branch
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="branch"
                options={branchList.map((item) => ({
                  value: item.name,
                  label: item.name,
                }))}
                value={reportData.branch}
                onChange={(selectedOption) =>
                  handleDropdownChange("branch", selectedOption)
                }
                success={reportData.branchStatus === "success" ? true : false}
                isClearable
              />
            </Grid>

            {/* Shift */}
            <Grid item xs={12} sm={6} md={4}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Shift
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="shift"
                options={shiftList.map((item) => ({
                  value: item?.name,
                  label: item?.name,
                }))}
                value={reportData.shift}
                onChange={(selectedOption) =>
                  handleDropdownChange("shift", selectedOption)
                }
                success={reportData.shiftStatus === "success" ? true : false}
                isClearable
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardContent>
          <MaterialBox
            display="flex"
            justifyContent="flex-start"
            alignItems="center"
            flexGrow={1}
          >
            <button
              onClick={exportToExcel}
              style={{
                marginBottom: "10px",
                padding: "8px 12px",
                background: "#4caf50",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Download Excel
            </button>
          </MaterialBox>

          {/* Table */}
          <MaterialDataGrid
            rows={rows || null}
            columns={columns || null}
            loading={loading}
            isSelectable={false}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Salary Report found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet added any Salary Report details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}

export default SalaryReport;
